import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar, { NavItem } from '@/components/Navbar';
import { ReactNode } from 'react';
import Home from '@/pages/Home';
import Footer from '@/components/Footer';
import { Toaster } from './components/ui/toaster';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './api/queryClient';
import FaqView from './pages/Faq/FaqView';
import RentalApplicationView from './pages/RentalApplication/RentalApplicationView';
import AvailablePropertiesView from './pages/AvailableProperties/AvailablePropertiesView';
import NotFoundView from './pages/NotFoundView';
import LoginView from './pages/Login/LoginView';
import AdminView from './pages/Admin/AdminView';
import ApplicationDetailView from './pages/Admin/ApplicationDetailView';
import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStatus } from './hooks/useAuthStatus';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

type Page = {
  path: string;
  element: ReactNode;
};

type LayoutProps = {
  children: ReactNode;
};

const navItems: Array<NavItem> = [
  {
    title: 'Hem',
    path: '/',
  },
  {
    title: 'Lediga bostäder',
    path: '/available-properties',
  },

  {
    title: 'Intresseanmälan',
    path: '/rental-application',
  },
  {
    title: 'För hyresgäster',
    path: '/faq',
  },
];

const authedNavItems: Array<NavItem> = [
  {
    title: 'Hem',
    path: '/',
  },
  {
    title: 'Lediga bostäder',
    path: '/available-properties',
  },

  {
    title: 'Intresseanmälan',
    path: '/rental-application',
  },
  {
    title: 'För hyresgäster',
    path: '/faq',
  },
  {
    title: 'Adminpanel',
    path: '/admin',
  },
];

const pages: Array<Page> = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/available-properties',
    element: <AvailablePropertiesView />,
  },
  {
    path: '/rental-application',
    element: <RentalApplicationView />,
  },
  { path: '/faq', element: <FaqView /> },
  { path: '/login', element: <LoginView /> },
  { path: '/admin', element: <AdminView /> },
  { path: '/admin/applications/:id', element: <ApplicationDetailView /> },
  { path: '*', element: <NotFoundView /> },
];

const Layout = ({ children }: LayoutProps) => {
  const { data: isAuthenticated } = useAuthStatus();

  return (
    <>
      <Navbar navItems={isAuthenticated ? authedNavItems : navItems} />
      <Toaster />
      <ScrollToTop />
      <Box minH="100vh">{children}</Box>
      <Footer />
    </>
  );
};

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Layout>
          <Routes>
            {pages.map(page => {
              return <Route key={page.path} path={page.path} element={page.element} />;
            })}
          </Routes>
        </Layout>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
